import React from 'react';
import BulletButton from '../../../../components/BulletButton';
import styles from './Body.module.css';
import smsReceiptImg from '../../../../assets/images/serverApp/payment/sms.png';
import emailReceiptImg from '../../../../assets/images/serverApp/payment/email.png';
import noReceiptImg from '../../../../assets/images/serverApp/payment/leafImg.png';

const Body = (props) => {
  const { onPressReceipt = () => { } } = props;
  const RECEIPT_BTN_CONFIG = [
    { name: 'TEXT RECEIPT', type: 'textReceipt', icon: smsReceiptImg },
    { name: 'EMAIL RECEIPT', type: 'emailReceipt', icon: emailReceiptImg },
    { name: 'NO RECEIPT', type: 'noReceipt', icon: noReceiptImg },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.receiptWrapper}>
        {RECEIPT_BTN_CONFIG.map(btn =>
          <BulletButton
            key={btn.name}
            direction={'right'}
            triangleBgColor={btn.type === 'noReceipt' ? '#6AB301' : '#fff'}
            buttonStyle={btn.type === "noReceipt" ? styles.noReceiptBackground : null}
            onClick={() => onPressReceipt(btn.type)}
          >
            <div key={btn.type} className={styles.receiptBtn}>
              <img src={btn.icon} className={styles.receiptIcon} />
              <span
                className={styles.receiptTxt}
                style={{ color: btn.type === "noReceipt" ? '#fff' : '#000' }}
              >
                {btn.name}
              </span>
            </div>
          </BulletButton>
        )}
      </div>
    </div>
  )
}

export default Body;
